import { cn } from "../../../../lib/utils";

interface DistributionTotalFooterProps {
  total: number;
}

const DistributionTotalFooter = ({ total }: DistributionTotalFooterProps) => (
  <p className={cn("tw-text-xs tw-font-mono", total > 100 ? "tw-text-destructive" : "tw-text-muted-foreground")}>
    Distribution total: {total}%
  </p>
);

export default DistributionTotalFooter;
